import { visuallyHidden } from "@mui/utils";
import {
  LACK_OF_CAPACITY_DOCUMENT,
  LEGAL_GUARDIAN,
  PREDICAMENT_STATE_YES,
} from "core/consts";
import { ValueOf } from "core/types";
import RadioGroupV2, { RadioOptionV2 } from "ds_legacy/components/RadioGroupV2";
import { RADIO_WHITE_BACKGROUND } from "ds_legacy/materials/colors";
import { margin, padding, sizing } from "ds_legacy/materials/metrics";
import { FONT_SIZE_14 } from "ds_legacy/materials/typography";
import {
  PatientFormSubheading,
  Section,
  SectionRow,
  TextInputWithLabel,
  YesNoRadioWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionTwelve = () => {
  const translations = useTranslations();

  const options: RadioOptionV2<ValueOf<typeof LEGAL_GUARDIAN>>[] = [
    {
      label: translations.patientForms.drvGeneralForm.sectionEleven.legalRep,
      value: LEGAL_GUARDIAN.STATUTORY_REP,
    },
    {
      label: translations.patientForms.drvGeneralForm.sectionEleven.guardian,
      value: LEGAL_GUARDIAN.CUSTODIAN,
    },
    {
      label: translations.patientForms.drvGeneralForm.sectionEleven.carer,
      value: LEGAL_GUARDIAN.SUPERVISOR,
    },
    {
      label:
        translations.patientForms.drvGeneralForm.sectionEleven
          .authorisedRepresentative,
      value: LEGAL_GUARDIAN.AUTHORIZED,
    },
  ];

  const optionsLackOfCapacity: RadioOptionV2<
    ValueOf<typeof LACK_OF_CAPACITY_DOCUMENT>
  >[] = [
    {
      label: translations.patientForms.drvGeneralForm.sectionEleven.attached,
      value: LACK_OF_CAPACITY_DOCUMENT.ATTACHED,
    },
    {
      label:
        translations.patientForms.drvGeneralForm.sectionEleven.submittedLater,
      value: LACK_OF_CAPACITY_DOCUMENT.SEND_LATER,
    },
  ];

  return (
    <Section
      title={translations.patientForms.drvGeneralForm.sectionEleven.title}
    >
      <PatientFormSubheading style={{ padding: padding(0, 0, 1) }}>
        {translations.patientForms.drvGeneralForm.sectionEleven.subtitle}
      </PatientFormSubheading>
      <YesNoRadioWithLabel
        elementName="third_party_request"
        formLabelSx={visuallyHidden}
        label={translations.patientForms.drvGeneralForm.sectionEleven.subtitle}
        shouldStartWithNo
        sideMutation={(_value, mutate) => {
          mutate(null, "contact_guardian");
          mutate(null, "legal_guardian_type");
          mutate(null, "legal_guardian_house_number");
          mutate(null, "legal_guardian_zip_code");
          mutate(null, "legal_guardian_town");
          mutate(null, "legal_guardian_phone");
          mutate(null, "legal_guardian_email");
          mutate(null, "consent_of_the_insured");
        }}
        subForms={{
          [PREDICAMENT_STATE_YES]: (
            <>
              <TextInputWithLabel
                elementName="contact_guardian"
                label={
                  translations.patientForms.drvGeneralForm.sectionEleven.nameRep
                }
                labelWrapperSx={{ width: "100%" }}
                style={{ margin: margin(0, 0, 1) }}
                withFlatModel
              />
              <RadioGroupV2
                elementName="legal_guardian_type"
                formControlLabelSx={{
                  marginLeft: 0,
                  paddingBottom: sizing(0.5),
                }}
                formLabelSx={{
                  fontSize: FONT_SIZE_14,
                  padding: padding(1, 0),
                }}
                label={
                  translations.patientForms.drvGeneralForm.sectionEleven
                    .legalGuardianType
                }
                options={options}
                radioSx={RADIO_WHITE_BACKGROUND}
                withFlatModel
              />
              <SectionRow>
                <TextInputWithLabel
                  elementName="legal_guardian_house_number"
                  isLarge
                  label={
                    translations.patientForms.drvGeneralForm.sectionEleven
                      .street
                  }
                  withFlatModel
                />
                <TextInputWithLabel
                  elementName="legal_guardian_zip_code"
                  label={
                    translations.patientForms.drvGeneralForm.sectionEleven
                      .zipCode
                  }
                  withFlatModel
                />
                <TextInputWithLabel
                  elementName="legal_guardian_town"
                  isLarge
                  label={
                    translations.patientForms.drvGeneralForm.sectionEleven.city
                  }
                  withFlatModel
                />
              </SectionRow>
              <SectionRow>
                <TextInputWithLabel
                  elementName="legal_guardian_phone"
                  isLarge
                  label={
                    translations.patientForms.drvGeneralForm.sectionEleven.phone
                  }
                  withFlatModel
                />
                <TextInputWithLabel
                  elementName="legal_guardian_email"
                  isLarge
                  label={
                    translations.patientForms.drvGeneralForm.sectionEleven.email
                  }
                  withFlatModel
                />
              </SectionRow>
              <RadioGroupV2
                elementName="consent_of_the_insured"
                formControlLabelSx={{
                  marginLeft: 0,
                  paddingBottom: sizing(0.5),
                }}
                formLabelSx={{
                  fontSize: FONT_SIZE_14,
                  padding: padding(3, 0, 1),
                }}
                label={
                  translations.patientForms.drvGeneralForm.sectionEleven
                    .lackOfCapacity
                }
                options={optionsLackOfCapacity}
                radioSx={RADIO_WHITE_BACKGROUND}
                withFlatModel
              />
            </>
          ),
        }}
      />
    </Section>
  );
};
